import dayjs from 'dayjs'
import minBy from 'lodash/minBy'
import maxBy from 'lodash/maxBy'

const calcWholePeriodOfBudgets = insertionOrderBudgets => {
  const dateFormat = 'YYYY-MM-DD'
  // 案件が無かったら今日〜３ヶ月後
  if (insertionOrderBudgets.length === 0)
    return {
      startDate: dayjs()
        .startOf('day')
        .format(dateFormat),
      endDate: dayjs()
        .add(3, 'month')
        .endOf('day')
        .format(dateFormat),
    }

  const startDate = minBy(
    insertionOrderBudgets.map(b => dayjs(b.summary.startTime).startOf('day')),
    d => d.unix(),
  ).format(dateFormat)
  const endDate = maxBy(
    insertionOrderBudgets.map(b => dayjs(b.summary.endTime).startOf('day')),
    d => d.unix(),
  ).format(dateFormat)

  return {
    startDate,
    endDate,
  }
}

export default calcWholePeriodOfBudgets
